import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { BuildContext } from '../providers';
export const useBuildContext = () => {
  const $ = _c(2);
  const context = useContext(BuildContext);
  if (context === undefined || context === null) {
    throw new Error("useBuildContext must be used within a BuildContext");
  }
  let t0;
  if ($[0] !== context) {
    t0 = {
      ...context
    };
    $[0] = context;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};